export class HttpService {
  // HTTP GET helper method
  public async get<T>(url: string, headersInfo?: HeadersInit): Promise<T> {
    const response = await fetch(url, { headers: headersInfo });
    if (!response.ok) {
      throw response;
    }
    return response.json() as Promise<T>;
  }

  public async post<T, TReturn>(
    url: string,
    obj: T,
    headersInfo?: HeadersInit
  ): Promise<TReturn> {
    const response = await fetch(url, {
      method: "POST",
      headers: headersInfo,
      body: JSON.stringify(obj),
    });
    if (!response.ok) {
      throw response;
    }
    return response.json() as Promise<TReturn>;
  }
  public async getText(
    url: string,
    headersInfo?: HeadersInit
  ): Promise<string> {
    const response = await fetch(url, { headers: headersInfo });
    if (!response.ok) {
      throw response;
    }
    return response.text();
  }
}
